module.exports = __webpack_public_path__ + "static/media/logo192.7c93a5ab.png";